/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * Lowest rate for a room/bed type filter, with optional room metadata
 * @export
 * @interface FilterRate
 */
export interface FilterRate {
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof FilterRate
     */
    total: CurrencyAmount;
    /**
     * Average nightly rate for this filter, when displayable
     * @type {CurrencyAmount | null}
     * @memberof FilterRate
     */
    nightly: CurrencyAmount | null;
    /**
     * Name/description of the room with the lowest rate for this filter
     * @type {string}
     * @memberof FilterRate
     */
    roomName?: string;
    /**
     * URL of an image of the room with the lowest rate for this filter
     * @type {string}
     * @memberof FilterRate
     */
    imageUrl?: string;
    /**
     * Room area in square feet, if available
     * @type {number}
     * @memberof FilterRate
     */
    areaSqFt?: number;
}

/**
 * Check if a given object implements the FilterRate interface.
 */
export function instanceOfFilterRate(value: object): value is FilterRate {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('nightly' in value) || value['nightly'] === undefined) return false;
    return true;
}

export function FilterRateFromJSON(json: any): FilterRate {
    return FilterRateFromJSONTyped(json, false);
}

export function FilterRateFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterRate {
    if (json == null) {
        return json;
    }
    return {
        
        'total': CurrencyAmountFromJSON(json['total']),
        'nightly': CurrencyAmountFromJSON(json['nightly']),
        'roomName': json['room_name'] == null ? undefined : json['room_name'],
        'imageUrl': json['image_url'] == null ? undefined : json['image_url'],
        'areaSqFt': json['area_sq_ft'] == null ? undefined : json['area_sq_ft'],
    };
}

export function FilterRateToJSON(json: any): FilterRate {
    return FilterRateToJSONTyped(json, false);
}

export function FilterRateToJSONTyped(value?: FilterRate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': CurrencyAmountToJSON(value['total']),
        'nightly': CurrencyAmountToJSON(value['nightly']),
        'room_name': value['roomName'],
        'image_url': value['imageUrl'],
        'area_sq_ft': value['areaSqFt'],
    };
}
